import type { CardHooks } from "./registry";
import { makeBuff } from "../playtestEngine";

/**
 * Shoulder Bash — Maneuver utility.
 * Effect: your next attack gains Displace.
 */
export const shoulderBash: CardHooks = {
  onUtilityPlay: (ctx) => ({
    queueSelfBuff: makeBuff(
      "Shoulder Bash",
      "next-attack",
      { kind: "gain-displace" },
      ctx.game.round,
    ),
    log: ["Shoulder Bash — next attack gains Displace"],
  }),
};
